// import React, { useEffect, useState } from "react";
// import { Tooltip, Modal, Box, Typography, CircularProgress } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link } from "react-router-dom";
// import PaginationComponent from "../../../Components/PaginationComponent";
// import toast from 'react-hot-toast';
// import roleService from "../../../Services/roleService";


// const Roles = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [roles, setRoles] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const getRoles = async () => {
//       try {
//         setLoading(true);
//         const response = await roleService.fetchAllRoles();
//         console.log(response);
//         setRoles(response.roles);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error('Error fetching doctors');
//       }
//     };
//     getRoles();
//   }, []);

//   useEffect(() => {
//     const filteredResult = roles?.filter(
//       (item) =>
//         item?.role_name?.toLowerCase().includes(searchData.toLowerCase())
//     ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, roles]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleViewClick = (doctor) => {
//     setSelectedDoctor(doctor);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedDoctor(null);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Roles</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">{filteredData?.length || 0} records found</h1>
        
//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           <Link to='AddEditRoles'>
//             <button className="bg-[#232233] h-[2rem] px-4 rounded-md text-white font-[600] text-[14px]">
//               + New Role
//             </button>
//           </Link>
//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%]">
//             <thead>
//               <tr className="text-[#101418] capitalize leading-normal text-sm">
//               <th className="py-[1%] w-[10%] text-gray-700 text-left pl-4">Sr No.</th>
//               <th className="py-[1%] w-[20%] text-gray-700 text-left pl-4">Role</th>
//               <th className="py-[1%] w-[20%] text-gray-700 text-left pl-4">Description</th>
//               <th className="py-[1%] w-[10%] text-gray-700 text-center">Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((role) => (
//                 <tr key={role?.role_id} className="bg-white text-gray-600 text-xs font-light border-t-[1px] border-gray-200">
//                   <td className="w-[10%] text-left">
//                     <p className="font-[600] text-gray-600 text-center">{role?.role_id}</p>
//                   </td>
//                   <td className="w-[20%] text-left">
//                     <p className="font-[600] text-gray-600 text-left">{role?.role_name}</p>
//                   </td>
//                   <td className="py-[1%] w-[20%] text-left pl-4">
//                     <p className="font-[600] text-gray-600">{role?.description}</p>
//                   </td>
                
//                    <td className="py-[2%] w-[10%] text-center">
//                     <button
//                       onClick={() => handleViewClick(role)}
//                       className=" font-[500] text-blue-500"
//                     >
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           data={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>

//       </div>
//   );
// };

// export default Roles;



import React, { useEffect, useState } from "react";
import { Modal, Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import roleService from "../../../Services/roleService";

const Roles = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const getRoles = async () => {
      try {
        setLoading(true);
        const response = await roleService.fetchAllRoles();
        setRoles(response.roles);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching roles");
      }
    };
    getRoles();
  }, []);

  useEffect(() => {
    const filtered =
      roles?.filter((item) =>
        item?.role_name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchData, roles]);

  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    setPaginatedData(filteredData?.slice(start, end) || []);
  }, [currentPage, filteredData]);

  const handleView = (role) => {
    setSelectedRole(role);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedRole(null);
  };

  return (
    <div className="p-3 sm:p-6">

      {/* ───────── HEADER ───────── */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">

        <div>
          <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800">
            Roles Table
          </h1>
          <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
            {filteredData?.length || 0} records found
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">

          {/* Search */}
          <div className="relative w-full sm:w-[230px]">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search role..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-8 pr-3 py-[8px] w-full text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none"
            />
          </div>

          {/* Button */}
          <Link to="AddEditRoles" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-4 py-[8px] rounded-lg">
              + New Role
            </button>
          </Link>

        </div>
      </div>

      {/* ───────── DESKTOP TABLE ───────── */}
      <div className="hidden md:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">

        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px]">

            <thead>
              <tr className="bg-[#215187] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">Sr No.</th>
                <th className="py-3 px-4 text-left">Role</th>
                <th className="py-3 px-4 text-left">Description</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="py-10 text-center text-gray-400">
                    Loading...
                  </td>
                </tr>
              ) : paginatedData?.length === 0 ? (
                <tr>
                  <td colSpan={4} className="py-10 text-center text-gray-400">
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData?.map((role) => (
                  <tr
                    key={role?.role_id}
                    className="border-t hover:bg-gray-50 text-[13px]"
                  >
                    <td className="py-3 px-4">{role?.role_id}</td>
                    <td className="py-3 px-4 font-[500]">{role?.role_name}</td>
                    <td className="py-3 px-4">{role?.description}</td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => handleView(role)}
                        className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>
      </div>

      {/* ───────── MOBILE CARDS ───────── */}
      <div className="md:hidden flex flex-col gap-3">

        {loading ? (
          <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
            Loading...
          </div>
        ) : paginatedData?.length === 0 ? (
          <div className="bg-white border rounded-xl py-10 text-center text-gray-400">
            No records found
          </div>
        ) : (
          paginatedData?.map((role) => (
            <div
              key={role?.role_id}
              className="bg-white border rounded-xl p-4 shadow-sm"
            >

              <div className="flex justify-between items-start mb-3">
                <div>
                  <p className="font-semibold text-gray-800">
                    {role?.role_name}
                  </p>
                  <p className="text-[11px] text-gray-400">
                    ID: {role?.role_id}
                  </p>
                </div>

                <button
                  onClick={() => handleView(role)}
                  className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md"
                >
                  View
                </button>
              </div>

              <p className="text-[12px] text-gray-600">
                {role?.description}
              </p>

            </div>
          ))
        )}

      </div>

      {/* ───────── PAGINATION ───────── */}
      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={10}
      />

      {/* ───────── MODAL ───────── */}
      <Modal open={isModalOpen}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: 420 },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >

          {/* Header */}
          <div className="bg-[#215187] px-5 py-4 flex justify-between items-center">
            <Typography className="!text-white !text-[15px] !font-semibold">
              Role Details
            </Typography>
            <button
              onClick={handleClose}
              className="text-white text-[20px]"
            >
              &times;
            </button>
          </div>

          {/* Body */}
          {selectedRole && (
            <div className="p-5 flex flex-col gap-3">

              <div className="flex justify-between">
                <span className="text-gray-500">Role ID</span>
                <span className="font-semibold">{selectedRole.role_id}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Role Name</span>
                <span className="font-semibold">{selectedRole.role_name}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">Description</span>
                <span className="text-right max-w-[60%]">
                  {selectedRole.description}
                </span>
              </div>

              <button
                onClick={handleClose}
                className="mt-3 bg-[#2F6DB4] text-white py-2 rounded-lg"
              >
                Close
              </button>

            </div>
          )}

        </Box>
      </Modal>

    </div>
  );
};

export default Roles;